module.exports = __webpack_public_path__ + "static/media/loading-gear.9f6a2e84.gif";